import React from 'react'
import { makeStyles } from '@material-ui/styles'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import theme from 'theme'
import { Grid, FormControl, TextField } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  item: {
    paddingLeft: '9px',
    paddingRight: '9px',
  },
  textoLivre: {
    marginTop: theme.spacing(1),
    paddingLeft: '9px',
    paddingRight: '9px',
  },
}))

export const SelectComposto = (props) => {
  const classes = useStyles()
  const {
    formState,
    nomePropriedadeInputText,
    nomePropriedadeSelect,
    options,
    handleChangeOption,
    handleChangeInputText,
    labelSelect,
    required,
    optionLabelFunction,
    disable,
    md,
    sm,
    mt,
    shrink,
  } = props

  const isOutroSelected =
    formState.values[nomePropriedadeSelect] &&
    formState.values[nomePropriedadeSelect].nome &&
    formState.values[nomePropriedadeSelect].nome.toLowerCase() === 'outro'

  return (
    <Grid
      style={{ marginTop: mt === 0 ? 0 : mt || theme.spacing(2) }}
      item
      md={isOutroSelected ? 12 : md || 6}
      sm={isOutroSelected ? 12 : sm || 6}
      xs={12}
    >
      <Grid className={classes.item} item md={12} sm={12} xs={12}>
        <FormControl
          style={{
            minWidth: '100%',
            maxWidth: '100%',
          }}
        >
          <AutocompleteNative
            disabled={disable}
            value={
              formState.values[nomePropriedadeSelect]
                ? formState.values[nomePropriedadeSelect]
                : null
            }
            getOptionSelected={(option, value) =>
              option.nome === value || option === value || option.nome === value.nome
            }
            name={nomePropriedadeSelect}
            noOptionsText="Sem informações"
            options={options}
            onChange={(event, newValue) => {
              handleChangeOption(event, newValue, nomePropriedadeSelect)
            }}
            getOptionLabel={(option) => {
              if (option.nome) {
                return optionLabelFunction ? optionLabelFunction(option.nome) : option.nome
              }
              return optionLabelFunction ? optionLabelFunction(option) : option
            }}
            renderOption={(option) =>
              optionLabelFunction ? optionLabelFunction(option.nome) : option.nome
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={labelSelect}
                required={required || false}
                error={
                  formState.touched[nomePropriedadeSelect] &&
                  formState.errors[nomePropriedadeSelect]
                }
                rows={2}
                helperText={
                  formState.touched[nomePropriedadeSelect] &&
                  formState.errors[nomePropriedadeSelect]
                    ? formState.errors[nomePropriedadeSelect][0]
                    : null
                }
                InputLabelProps={{
                  shrink,
                }}
              />
            )}
          />
        </FormControl>
      </Grid>
      {isOutroSelected && (
        <Grid className={classes.textoLivre}>
          <FormControl
            style={{
              minWidth: '100%',
              maxWidth: '100%',
            }}
          >
            <TextField
              // error={hasError("descricao")}
              fullWidth
              // helperText={
              //  hasError("descricao") ? formState.errors.descricao[0] : null
              // }
              label={`${labelSelect} - texto livre`}
              name={nomePropriedadeInputText}
              onBlur={handleChangeInputText}
              defaultValue={
                formState.values[nomePropriedadeInputText]
                  ? formState.values[nomePropriedadeInputText]
                  : ''
              }
              InputLabelProps={{
                shrink,
              }}
              variant="outlined"
            />
          </FormControl>
        </Grid>
      )}
    </Grid>
  )
}
